import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Please confirm")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "First Name/Middle Name/Last Name", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Birth Date", -1)
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Country of Nationality", -1)
const _hoisted_14 = { class: "col-lg-8" }
const _hoisted_15 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Job Classification", -1)
const _hoisted_18 = { class: "col-lg-8" }
const _hoisted_19 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_20 = { class: "row mb-7" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Username", -1)
const _hoisted_22 = { class: "col-lg-8" }
const _hoisted_23 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_24 = { class: "row mb-7" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Sponsor", -1)
const _hoisted_26 = { class: "col-lg-8" }
const _hoisted_27 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_28 = { class: "row mb-7" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Upline", -1)
const _hoisted_30 = { class: "col-lg-8" }
const _hoisted_31 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_32 = { class: "row mb-7" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Position", -1)
const _hoisted_34 = { class: "col-lg-8" }
const _hoisted_35 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_36 = { class: "row mb-7" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Mobile#", -1)
const _hoisted_38 = { class: "col-lg-8" }
const _hoisted_39 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_40 = { class: "row mb-7" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Email", -1)
const _hoisted_42 = { class: "col-lg-8" }
const _hoisted_43 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_44 = { class: "row mb-7" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Block Number and Street", -1)
const _hoisted_46 = { class: "col-lg-8" }
const _hoisted_47 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_48 = { class: "row mb-7" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Name of Building(Optional)", -1)
const _hoisted_50 = { class: "col-lg-8" }
const _hoisted_51 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_52 = { class: "row mb-7" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Unit Number (Optional)", -1)
const _hoisted_54 = { class: "col-lg-8" }
const _hoisted_55 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_56 = { class: "row mb-7" }
const _hoisted_57 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "City, Province, Country", -1)
const _hoisted_58 = { class: "col-lg-8" }
const _hoisted_59 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_60 = { class: "row mb-7" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Beneficiary First Name/Middle Name/Last Name", -1)
const _hoisted_62 = { class: "col-lg-8" }
const _hoisted_63 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_64 = { class: "row mb-7" }
const _hoisted_65 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Beneficiary Birth Date", -1)
const _hoisted_66 = { class: "col-lg-8" }
const _hoisted_67 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_68 = { class: "row mb-7" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Beneficiary Contact", -1)
const _hoisted_70 = { class: "col-lg-8" }
const _hoisted_71 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_72 = { class: "row mb-7" }
const _hoisted_73 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Relationship with Insured", -1)
const _hoisted_74 = { class: "col-lg-8" }
const _hoisted_75 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_76 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6" }
const _hoisted_77 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_78 = { class: "d-flex flex-stack flex-grow-1 " }
const _hoisted_79 = { class: " fw-bold" }
const _hoisted_80 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "Network Setup confirmation", -1)
const _hoisted_81 = { class: "fs-6 text-gray-600 " }
const _hoisted_82 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" as your Sponsor and you will be placed on the ")
const _hoisted_84 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" below your upline ")
const _hoisted_86 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_87 = {
  key: 0,
  class: "pt-5"
}
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Your original requested upline is ")
const _hoisted_89 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "pt-5" }, " Please click Continue to Proceed ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.formdata.insured_firstName) + "/" + _toDisplayString(_ctx.formdata.insured_middleName) + "/" + _toDisplayString(_ctx.formdata.insured_lastName), 1)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.formdata.insured_birthday), 1)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.formdata.country_text2), 1)
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _createVNode("span", _hoisted_19, _toDisplayString(_ctx.formdata.job_classification_text), 1)
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("div", _hoisted_22, [
          _createVNode("span", _hoisted_23, _toDisplayString(_ctx.formdata.username), 1)
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode("div", _hoisted_26, [
          _createVNode("span", _hoisted_27, _toDisplayString(_ctx.formdata.sponsorid), 1)
        ])
      ]),
      _createVNode("div", _hoisted_28, [
        _hoisted_29,
        _createVNode("div", _hoisted_30, [
          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.formdata.uplineid), 1)
        ])
      ]),
      _createVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode("div", _hoisted_34, [
          _createVNode("span", _hoisted_35, _toDisplayString(_ctx.formdata.position), 1)
        ])
      ]),
      _createVNode("div", _hoisted_36, [
        _hoisted_37,
        _createVNode("div", _hoisted_38, [
          _createVNode("span", _hoisted_39, _toDisplayString(_ctx.formdata.insured_mobileNumber), 1)
        ])
      ]),
      _createVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode("div", _hoisted_42, [
          _createVNode("span", _hoisted_43, _toDisplayString(_ctx.formdata.insured_email), 1)
        ])
      ]),
      _createVNode("div", _hoisted_44, [
        _hoisted_45,
        _createVNode("div", _hoisted_46, [
          _createVNode("span", _hoisted_47, _toDisplayString(_ctx.formdata.address_blockAndStreet), 1)
        ])
      ]),
      _createVNode("div", _hoisted_48, [
        _hoisted_49,
        _createVNode("div", _hoisted_50, [
          _createVNode("span", _hoisted_51, _toDisplayString(_ctx.formdata.address_nameOfBuilding), 1)
        ])
      ]),
      _createVNode("div", _hoisted_52, [
        _hoisted_53,
        _createVNode("div", _hoisted_54, [
          _createVNode("span", _hoisted_55, _toDisplayString(_ctx.formdata.address_unitNumber), 1)
        ])
      ]),
      _createVNode("div", _hoisted_56, [
        _hoisted_57,
        _createVNode("div", _hoisted_58, [
          _createVNode("span", _hoisted_59, _toDisplayString(_ctx.formdata.address_city) + ", " + _toDisplayString(_ctx.formdata.province_text) + ", " + _toDisplayString(_ctx.formdata.country_text) + " (" + _toDisplayString(_ctx.formdata.address_postalCode) + ")", 1)
        ])
      ]),
      _createVNode("div", _hoisted_60, [
        _hoisted_61,
        _createVNode("div", _hoisted_62, [
          _createVNode("span", _hoisted_63, _toDisplayString(_ctx.formdata.beneficiary_firstName) + "/" + _toDisplayString(_ctx.formdata.beneficiary_middleName) + "/" + _toDisplayString(_ctx.formdata.beneficiary_lastName), 1)
        ])
      ]),
      _createVNode("div", _hoisted_64, [
        _hoisted_65,
        _createVNode("div", _hoisted_66, [
          _createVNode("span", _hoisted_67, _toDisplayString(_ctx.formdata.beneficiary_birthday), 1)
        ])
      ]),
      _createVNode("div", _hoisted_68, [
        _hoisted_69,
        _createVNode("div", _hoisted_70, [
          _createVNode("span", _hoisted_71, _toDisplayString(_ctx.formdata.beneficiary_contact), 1)
        ])
      ]),
      _createVNode("div", _hoisted_72, [
        _hoisted_73,
        _createVNode("div", _hoisted_74, [
          _createVNode("span", _hoisted_75, _toDisplayString(_ctx.formdata.beneficiary_relationship), 1)
        ])
      ]),
      _createVNode("div", _hoisted_76, [
        _createVNode("span", _hoisted_77, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
        ]),
        _createVNode("div", _hoisted_78, [
          _createVNode("div", _hoisted_79, [
            _hoisted_80,
            _createVNode("div", _hoisted_81, [
              _createTextVNode(_toDisplayString(_ctx.formdata.insured_firstName) + ", you are requesting to register a new account with ", 1),
              _createVNode("a", _hoisted_82, _toDisplayString(_ctx.formdata.responsedata.sponsorname) + " (" + _toDisplayString(_ctx.formdata.sponsorid) + ")", 1),
              _hoisted_83,
              _createVNode("a", _hoisted_84, _toDisplayString(_ctx.formdata.position == 'L' ? 'Left' : 'Right'), 1),
              _hoisted_85,
              _createVNode("a", _hoisted_86, _toDisplayString(_ctx.formdata.responsedata.uplinename) + " (" + _toDisplayString(_ctx.formdata.responsedata.actualuplineid) + ") ", 1),
              (_ctx.formdata.uplineid !=  _ctx.formdata.responsedata.actualuplineid)
                ? (_openBlock(), _createBlock("div", _hoisted_87, [
                    _hoisted_88,
                    _createVNode("a", _hoisted_89, _toDisplayString(_ctx.formdata.responsedata.requesteduplinename) + " (" + _toDisplayString(_ctx.formdata.uplineid) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_90
            ])
          ])
        ])
      ])
    ])
  ]))
}